



































































































































import { Vue, Component } from 'vue-property-decorator';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import DateFormat from '@/shared/utils/date-format';
import EventBus, { Event } from '@/event.bus'
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import Response from '@/domain/response.entity';
import Pagination from '@/domain/pagination.entity';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import RuleGroupFilter from '@/domain/scripts/entity/rule-group-filter.entity';
import RuleGroupService from '@/domain/scripts/service/rule-group.service';
import RuleGroup from '@/domain/scripts/entity/rule-group.entity';
import FilterComponent from './scripts-filter.component.vue';
import Header from './header-rule-group.json';

@Component({
  components: {
    FilterComponent, VbPagination, VbTooltipSlot, ModalWarning,
  },
  filters: {
    formatDate(value: string) {
      return DateFormat.timestampToLocal(value.split('T')[0]);
    },
  },
})

export default class RuleGroupDatatable extends Vue {
  showFilter: boolean = false;

  header = Header;

  filter: RuleGroupFilter = RuleGroupFilter.of({});

  warningModal: boolean = false;

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    sortBy: [],
    defaultSort: 'name|asc',
  });

  ruleGroupList: RuleGroup[] = [];

  businessUnitId: string = '';

  modalType = '';

  notApplyTooltipText: string = 'Não é possível remover regras publicadas';

  warningMessage = '';

  selectedRuleGroup: RuleGroup = RuleGroup.of({});

  openNewRuleGroup() {
    this.$emit('newRuleGroup');
  }

  handleWarningModal(ruleGroup: RuleGroup, value: string) {
    this.warningModal = true;
    this.selectedRuleGroup = ruleGroup;
    this.modalType = value;
    if (value === 'approval') {
      this.warningMessage = 'Deseja realmente prosseguir? Ao clicar no botão Sim, a regra será imediatamente aprovada e não será mais possivel realizar alterações'
    }
    if (value === 'deletion') {
      this.warningMessage = 'Deseja realmente prosseguir? Ao clicar no botão Sim, a regra será imediatamente removida'
    }
  }

  handleConfirm() {
    if (this.modalType === 'deletion') {
      this.deleteRuleGroup(this.selectedRuleGroup)
    }
    if (this.modalType === 'approval') {
      this.deleteRuleGroup(this.selectedRuleGroup)
    }
    this.closeWarningModal()
  }

  created() {
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    if (this.businessUnitId) {
      EventBus.$off(Event.BUSINESS_UNIT_SELECTED);
    }
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && this.$route.name.includes('Configuration')) {
        this.businessUnitId = businessUnit.id;
        this.pagination.page = 1
        this.findRulesGroup(this.filter);
      }
    })
    this.findRulesGroup(this.filter);
  }

  applyFilter(filter: RuleGroupFilter) {
    this.$route.params.status = filter.status;
    this.filter = RuleGroupFilter.of(filter);
    this.pagination.page = 1;
    this.findRulesGroup(this.filter);
  }

  findRulesGroup(filter: RuleGroupFilter) {
    if (this.businessUnitId) {
      RuleGroupService.filterRulesGroup(this.pagination, this.businessUnitId, filter)
        .then((response: Response) => {
          this.ruleGroupList = RuleGroup.ofList(response.content);
          this.pagination.total = response.totalElements;
          this.pagination.pageCount = response.totalPages;
        })
        .catch((err: any) => VbSnackbarService.handleHttpError(err));
    }
  }

  updateTable(pagination: Pagination) {
    this.pagination.verifyPage();
    this.findRulesGroup(this.filter);
  }

  get menuIcon(): string {
    return this.showFilter ? 'mdi-filter' : 'mdi-filter-outline'
  }

  editTooltipText(isApproved: boolean): string {
    return isApproved ? 'Editar' : this.notApplyTooltipText;
  }

  approvalTooltipText(isApproved: boolean): string {
    return isApproved ? 'Aprovar' : this.notApplyTooltipText;
  }

  deleteTooltipText(isApproved: boolean): string {
    return isApproved ? 'Deletar' : this.notApplyTooltipText;
  }

  approveRuleGroup(ruleGroup: RuleGroup) {
    RuleGroupService.approveRuleGroup(this.businessUnitId, ruleGroup.id)
      .then(() => {
        VbSnackbarService.showSuccess('Agrupamento de Regra aprovada com sucesso');
        ruleGroup.approve();
        this.findRulesGroup(this.filter);
      }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  deleteRuleGroup(ruleGroup: RuleGroup) {
    RuleGroupService.deleteRuleGroup(this.businessUnitId, ruleGroup.id)
      .then(() => {
        VbSnackbarService.showSuccess('Agrupamento de Regra removida com sucesso');
        this.findRulesGroup(this.filter);
      }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  closeWarningModal() {
    this.warningModal = false;
  }

  editRuleRuleGroup(ruleGroupId: string) {
    this.$emit('editRuleGroup', ruleGroupId);
  }

  preview(ruleGroupId: string) {
    this.$emit('previewRuleGroup', ruleGroupId);
  }
}

